export const RESOURCE = 'county';
export const ACTIONS = { Get: '' }